import { StyleSheet, Text, View, Image, TouchableOpacity, Dimensions, StatusBar, Animated, ScrollView, ImageBackground, TextInput, TouchableWithoutFeedback, FlatList, Alert} from 'react-native';
import React, {useRef, useState, useEffect, Component} from 'react';
import { FontAwesome5, Feather, MaterialIcons } from '@expo/vector-icons'
import AppLoader, { showLoader, loaderRef, hideLoader } from './AppLoader';
import { SafeAreaView } from 'react-native-safe-area-context';
import { ActivityIndicator } from 'react-native';
import * as SQLite from 'expo-sqlite';
import * as RootNavigation from '../RootNavigation';
import { createRecentTable, getRecents } from './getData';
import { color } from "react-native-reanimated";
import {  icons,
  images,
  theme,
  COLORS,
  SIZES,
  FONTS,
  dummyData
} from "../constants"

const {width, height} = Dimensions.get('window')

const db = SQLite.openDatabase("Users.db");

const newSeasonScrollX = React.createRef(new Animated.Value(0)).current;

  
export default class Home extends Component {
  
  constructor(props) {
    super(props);
    this.state = {
            background: {},
            gallery: [],
            list: [],
            recentLength: 0,
            
            
        }

        
  
      }

      componentDidMount() {
       showLoader();


         createRecentTable();

         
       db.transaction(
        (tx) => {
           tx.executeSql("select * from recents where 1 order by id desc limit 5", [], (_, { rows }) => {
            console.log(rows._array)
            this.setState({recentLength: rows.length, recent: rows._array})
            //rows.length
        });
        },
        null
      );


         // getRecents();
       //fetch movies from ios.breketefamily.com/getMovies.php
        fetch('https://ios.breketefamily.com/getMovies.php')
        .then((response) => response.json())
        .then((responseJson) => {
        // console.log(responseJson)
          if(responseJson.status == 0){
            this.setState({
              gallery: responseJson.movies,
              background: {'uri': responseJson.movies[0].image, 'name': responseJson.movies[0].name, 'stat': responseJson.movies[0].released, 'desc': responseJson.movies[0].desc},
              list: responseJson.movies,
            }, () => {
              hideLoader();
              console.log(responseJson.movies)
            })
            
          }else{
            hideLoader();
            Alert.alert('Error', responseJson.message);
          }

         
        }
        )
        .catch((error) => {
          hideLoader();
          console.error(error);
        }
        );
      
      }

      
 routeRecents = () => {
  this.props.navigation.navigate('Recents')
}
render() {
return (
<SafeAreaView
  style={{
    flex: 1,
    backgroundColor: '#fff',
  }}
>

      <AppLoader ref = { loaderRef } />
     
  <View style={{ flex: 1 }}>
  <ScrollView
    contentContainerStyle={{
      paddingBottom: 250,
    }}
  >
       <Image
            source={require("../assets/minibg.jpg")}
            style={{ width: 350, height: 150 }}
          />
        
        <View
          style={{
            flexDirection: "row",
            justifyContent: "space-around",
            alignItems: "center",
            marginTop: 20,
          }}
        >
          <Text
            style={{
              backgroundColor: "#000",
              color: "#fff",
              fontWeight: "bold",
              padding: 5,
              paddingLeft: 12,
              paddingRight: 12,
              borderRadius: 4,
            }}
          >
            All
          </Text>
          <Text
            style={{
              backgroundColor: "#000",
              color: "#fff",
              fontWeight: "bold",
              padding: 5,
              paddingLeft: 12,
              paddingRight: 12,
              borderRadius: 4,
            }}
          >
            Paid Programmes
          </Text>
          <Text
            style={{
              backgroundColor: "#000",
              color: "#fff",
              fontWeight: "bold",
              padding: 5,
              paddingLeft: 12,
              paddingRight: 12,
              borderRadius: 4,
            }}
          >
            Series
          </Text>
          <Text
            style={{
              backgroundColor: "#000",
              color: "#fff",
              fontWeight: "bold",
              padding: 5,
              paddingLeft: 12,
              paddingRight: 12,
              borderRadius: 4,
            }}
          >
            Sports
          </Text>
          <Text
            style={{
              backgroundColor: "#000",
              color: "#fff",
              fontWeight: "bold",
              padding: 5,
              paddingLeft: 12,
              paddingRight: 12,
              borderRadius: 4,
            }}
          >
            Live Tv
          </Text>
        </View>

        

        <Text
          style={{
            marginTop: 20,
            fontWeight: "bold",
            fontSize: 20,
            marginLeft: 10,
            marginBottom: 70,
          }}
        >
          Top Content
        </Text>

        <View
          style={{
            flexDirection: "row",
            justifyContent: "space-around",
            alignItems: "center",
            marginTop: 10,
            flexWrap: "wrap",
            marginBottom: 70,
          }}
        >
          
          {this.state.list.map((item, index) => {
            return (
              <View
              key={item.key}
              style={{
                flexDirection: "row",
                justifyContent: "space-around",
                marginTop: 10,
                flexWrap: "wrap",
                             }}
            >
              <TouchableOpacity
                key={item.key}
                style={{
                  width: (width - 40) / 3,
                  height: (width - 40) / 3,
                  margin: 10,
                  borderRadius: 10,
                  backgroundColor: "#000",
                  justifyContent: "center",
                  alignItems: "center",
                }}
                onPress={() => {
                  this.props.navigation.navigate('Player', {
                    movie: item,
                  });
                }}
              >
             <Image
            source={item.image}
            style={{
              height: 200,
              width: 160,
              borderRadius: 10,
            }}
          />
                <Text
                  style={{
                    color: "#fff",
                    fontWeight: "bold",
                    fontSize: 15,
                  }}
                >
                  {item.title}
                </Text>
              </TouchableOpacity>
            </View>
            );
          })
          
        }
          
        </View>
      </ScrollView>
    </View>
  </SafeAreaView>
);
  
  }
}